// extracted by mini-css-extract-plugin
export default {"navLocation":"OpDivReferral-module__navLocation--wbksN"};